// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"223":"c1e41663","279":"fec0be3a","315":"f8a0aef6"}[chunkId] + ".chunk.css";
};